import React from 'react';

const PressReleases = () => {
  const releases = [
    { title: 'ABVIG Announces 2026 Summit Dates', date: 'June 15, 2026' },
    { title: 'New Investment Partnership with European Union', date: 'May 22, 2026' },
    { title: 'ABVIG Expands Operations to East Africa', date: 'April 10, 2026' },
    { title: 'Business Incubator Program Launches', date: 'March 5, 2026' },
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Press Releases</h1>
        <p>Latest news and announcements</p>
      </section>
      <section className="page-content">
        <div className="container">
          {releases.map((release, index) => (
            <div className="release-item" key={index}>
              <h3>{release.title}</h3>
              <p style={{color: '#C8A95C', fontSize: '0.9rem'}}>{release.date}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default PressReleases;